import _slicedToArray from "/Users/yawjosephetse/Developer/repetere/periodicjs.ext.reactapp/adminclient/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import RoutesModule from 'routes';
var Router = RoutesModule;
/**
 * Catches all events on event emitter passed to the function
 * @param {Event Emitter} emitter - websocket/socket.io(client/server)/event emitter to intercept all incoming events
 * @param {Function} handler - socket.io like middleware (calls handler with packet and next) 
 */

function patchEmitter(emitter, handler) {
  emitter._onevent = emitter.onevent;

  var next = function next() {}; // Replace the onevent function with a handler that captures all messages


  emitter.onevent = function (packet) {
    handler(packet.data, next); // DO NOT USE https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#3-managing-arguments
    // emitter._onevent.apply(emitter, Array.prototype.slice.call(arguments));

    var args = new Array(arguments.length);

    for (var i = 0; i < args.length; ++i) {
      args[i] = arguments[i];
    }

    emitter._onevent.apply(emitter, args);
  };
}
/**
 * Returns socket.io like middleware function to handle incoming events based on their path
 * @param {Event emitter} options.socket - websocket/socket.io(client/server)/event emitter
 * @param {object} options.router - routes object 
 * @see https://www.npmjs.com/package/routes
 * @return {function} router handler middleware function
 */


function routerMiddleware(_ref) {
  var socket = _ref.socket,
      router = _ref.router;
  return function routeHandler(packet, next) {
    // console.log({ packet, socket });
    var _packet = _slicedToArray(packet, 2),
        path = _packet[0],
        body = _packet[1];

    var match = router.match(path);
    var req = {
      path: path,
      body: body,
      socket: socket
    };

    var cb = function cb(data) {
      return data;
    };

    var res = {
      send: function send(data) {
        try {
          socket.emit(path, cb(data));
          cb = null;
        } catch (e) {
          socket.emit('error', new Error('Response already sent'));
        }
      }
    };

    if (match) {
      req.params = match.params;
      req.splats = match.splats;
      match.fn(req, res, match);
    }

    next();
  };
}
/**
 * Responds to events based on their route and a router
 * @param {Event emitter} options.socket - websocket/socket.io(client/server)/event emitter
 * @param {object} options.router - routes object 
 * @see https://www.npmjs.com/package/routes
 */


function EventRouter(_ref2) {
  var socket = _ref2.socket,
      router = _ref2.router;

  if (socket.use) {
    socket.use(routerMiddleware({
      socket: socket,
      router: router
    }));
  } else {
    patchEmitter(socket, routerMiddleware({
      socket: socket,
      router: router
    }));
  }
}

export { Router, EventRouter };